import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { checkValidity, promptUser } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Dependencies
import currencyFormatter from 'currency-formatter';
import DatePicker from 'react-datepicker';
import moment from 'moment';

// Components
import * as icons from '../Icons/Icons';
import LoadMore from '../Common/LoadMore';

const InstitutionTransactions = observer(class InstitutionTransactions extends React.Component {
  constructor() {
    super();

    // Bind this to functions
    this.exportReport = this.exportReport.bind(this);
    this.completeExport = this.completeExport.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.resetFilters = this.resetFilters.bind(this);
  }

  componentWillMount() {
    this.props.store.AdminStore.getTransactions();

    this.state = {
      startDate: null,
      endDate: null
    }
  }

  highlight(amount, highlightPositive) {
    // if(amount < 0) {
    //   return 'negative';
    // } else if(amount > 0 && highlightPositive) {
    //   return 'positive';
    // }

    return '';
  }

  exportReport() {
    const { translation } = this.props;
    const { ReportStore } = this.props.store;

    // Set the default export title
    ReportStore.reportExportTitle = translation.page_title;

    // Show a dialog to let the user change the title
    const msg = {
      heading: translation.csv_prompt.heading,
      input: translation.csv_prompt.input,
      button: translation.csv_prompt.button
    }

    promptUser(msg, this.completeExport, null, ReportStore.reportExportTitle);
  }

  completeExport() {
    const { translation } = this.props;
    const { ReportStore, SessionStore } = this.props.store;

    const callback = () => SessionStore.showToaster(translation.exported, 'success');

    ReportStore.exportData(callback);
  }

  handleDateChange(date, name) {
    this.setState({
      [name]: date
    }, () => {
      if(this.state.startDate && this.state.endDate === null) {
        this.endDate.setFocus();
      } else if(this.state.endDate && this.state.startDate === null) {
        this.startDate.setFocus();
      }
    });
  }

  applyFilters(e) {
    e.preventDefault();

    const { AdminStore, SessionStore } = this.props.store;
    const { userTimezone } = SessionStore;

    const { startDate, endDate } = this.state;
    const type = this.type.value;
    const examStatus = this.examStatus.value;
    const filters = {};

    if(startDate) {
      filters.dateRangeStart = moment(startDate).tz(userTimezone).toISOString();
    }

    if(endDate) {
      filters.dateRangeEnd = moment(endDate).tz(userTimezone).toISOString();
    }

    if(type) {
      filters.type = type;
    }

    if(examStatus) {
      filters.examStatus = examStatus;
    }

    AdminStore.ledgerFilters = filters;

    if(Object.keys(filters).length > 0) {
      AdminStore.getTransactions();
    } else {
      this.resetFilters();
    }
  }

  resetFilters() {
    const { AdminStore } = this.props.store;

    this.setState({
      startDate: null,
      endDate: null
    });

    this.type.value = '';
    this.examStatus.value = '';

    AdminStore.ledgerFilters = {};

    AdminStore.getTransactions();
  }

  renderResults() {
    const { translation, store } = this.props;
    const { summary, transactions } = store.AdminStore;
    const { userTimezone } = this.props.store.SessionStore;

    if(transactions.length > 0) {
      return (
        <div>
          <h4 className="total">
            {translation.current_balance}:
            <span className={this.highlight(summary.balance, true)}>
              {currencyFormatter.format(summary.balance, {code: transactions[0].currency})} {transactions[0].currency}
            </span>
          </h4>

          <table>
            <thead>
              <tr>
                <th className="subtitle" scope="col">{translation.date}</th>
                <th className="subtitle" scope="col">{translation.notes}</th>
                <th className="subtitle number" scope="col">{translation.amount}</th>
              </tr>
            </thead>
            <tbody className="panel__body">
              {transactions.map(
                (key, i) =>
                <tr key={i}>
                  <td>
                    {moment.utc(key.createdDate)
                           .tz(userTimezone)
                           .format('M/D/YYYY [at] h:mma z')}
                  </td>
                  <td>
                    {key.voucherSid && key.voucher &&
                      <ul className="table-list">
                        <li>
                          {currencyFormatter.format(
                            key.voucher.amount, {code: key.currency}
                          )} {translation.voucher}
                        </li>
                        <li>
                          {translation.voucher_code}: {key.voucher.voucherCode}
                        </li>
                      </ul>
                    }

                    {key.memo &&
                      <p>{key.memo}</p>
                    }

                    {key.fundingRuleSid && key.fundingRule &&
                      <ul className="table-list">
                        <li>
                          {translation.funding_rule}:&nbsp;
                          {key.fundingRule.title}
                        </li>
                        <li>
                          {translation.amount}:&nbsp;

                          {key.fundingRule.units === '%' &&
                            `${key.fundingRule.amount}%`
                          }

                          {key.fundingRule.units === '$' &&
                            currencyFormatter.format(
                              key.fundingRule.amount, {code: key.fundingRule.currency}
                            )
                          }
                        </li>
                      </ul>
                    }

                    {key.examSessionSid && key.examSession &&
                      <ul className="table-list">
                        <li>
                          {translation.exam}:&nbsp;
                          {key.exam.title}
                        </li>
                        <li>
                          {translation.course}:&nbsp;
                          {key.course.title}
                        </li>
                        <li>
                          {translation.student}:&nbsp;
                          {key.student.lastName}, {key.student.firstName}
                        </li>
                        {key.student.address &&
                          <li>
                            {translation.address}:&nbsp;
                            {key.student.address}
                          </li>
                        }
                        {key.student.latitude &&
                          <li>
                            {translation.latitude}:&nbsp;
                            {key.student.latitude}
                          </li>
                        }
                        {key.student.longitude &&
                          <li>
                            {translation.longitude}:&nbsp;
                            {key.student.longitude}
                          </li>
                        }
                        <li>
                          {translation.appointment_date}:&nbsp;
                          {moment.utc(key.examSession.appointmentDate)
                                 .tz(userTimezone)
                                 .format('M/D/YYYY [at] h:mma z')}
                        </li>
                        <li>
                          {translation.status}:&nbsp;
                          {key.examSession.status}
                        </li>
                      </ul>
                    }
                  </td>
                  <td
                    className={`number ${this.highlight(key.amount, false)}`}
                  >
                    {currencyFormatter.format(
                      key.amount, {code: key.currency}
                    )} {key.currency}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )
    } else {
      return (
        <span className="no-results">
          {this.state.startDate && this.state.endDate &&
            translation.no_results_filtered
          }

          {(!this.state.startDate || !this.state.endDate) &&
            translation.no_results
          }
        </span>
      )
    }
  }

  render() {
    const { translation } = this.props;
    const { AdminStore } = this.props.store;
    const { transactions, transactionsNext } = AdminStore;

    return(
      <main tabIndex="0" id="main-content" className="page">
        <header className="page__header">
          <div className="wrap">
            <h1 className="page__title">{translation.page_title}</h1>

            <div className="page__actions actions">
              <button
                className="btn--outline"
                onClick={this.exportReport}
              >
                <icons.iconDownload />
                {translation.csv_button}
              </button>
            </div>
          </div>
        </header>

        <form
          className="filter"
          onSubmit={(e) => checkValidity(e, (e) => this.applyFilters(e))}
          noValidate
        >
          <div className="wrap">
            <fieldset className="filter__filters">
              <ul className="fields fields--inline">
                <li>
                  <legend>{translation.filter}:</legend>
                </li>
                <li>
                  <label className="select">
                    <select
                      ref={(input) => { this.type = input }}
                    >
                      <option value="">{translation.filters.type.all}</option>
                      <option value="fundingRule">
                        {translation.filters.type.funding_rule}
                      </option>
                      <option value="voucher">
                        {translation.filters.type.voucher}
                      </option>
                      <option value="credit">
                        {translation.filters.type.credit}
                      </option>
                    </select>
                  </label>
                </li>
                <li>
                  <label className="select">
                    <select
                      ref={(input) => { this.examStatus = input }}
                    >
                      <option value="">{translation.filters.examStatus.all}</option>
                      <option value="active">
                        {translation.filters.examStatus.active}
                      </option>
                      <option value="draft">
                        {translation.filters.examStatus.draft}
                      </option>
                      <option value="deleted">
                        {translation.filters.examStatus.deleted}
                      </option>
                    </select>
                  </label>
                </li>
                <li>
                  <label className="meta" htmlFor="startDate">
                    {translation.filters.start_date}
                  </label>

                  <DatePicker
                    id="startDate"
                    selected={this.state.startDate}
                    maxDate={this.state.endDate}
                    onChange={(date) => this.handleDateChange(date, 'startDate')}
                    placeholderText={translation.filters.start_date}
                    autoComplete="off"
                    required={this.state.endDate}
                    ref={(input) => this.startDate = input}
                  />

                  <span className="preposition">–</span>

                  <label className="meta" htmlFor="endDate">
                    {translation.filters.end_date}
                  </label>

                  <DatePicker
                    id="endDate"
                    selected={this.state.endDate}
                    minDate={this.state.startDate}
                    onChange={(date) => this.handleDateChange(date, 'endDate')}
                    placeholderText={translation.filters.end_date}
                    autoComplete="off"
                    required={this.state.startDate}
                    ref={(input) => this.endDate = input}
                  />
                </li>
              </ul>
            </fieldset>

            <div className="actions">
              <button
                className="btn"
                type="submit"
              >
                {translation.filter}
              </button>

              <button
                className="btn btn--outline"
                type="reset"
                onClick={this.resetFilters}
              >
                {translation.reset}
              </button>
            </div>
          </div>
        </form>

        <div className="wrap">
          {this.renderResults()}

          {transactionsNext &&
            <LoadMore
              url={transactionsNext}
              group={transactions}
              text="Load more transactions"
              {...this.props}
            />
          }
        </div>
      </main>
    );
  }
})

export default translate('InstitutionTransactions')(InstitutionTransactions);



// WEBPACK FOOTER //
// ./src/app/components/Account/InstitutionTransactions.js